import type { ComputerMcq, ComputerMcqUnit } from "~/features/computer/types/computer";

export const researchedPythonMcqAdditionsByGroup: Record<string, ComputerMcq[]> = {
  variables: [
    {
      id: "py-extra-var-1",
      difficulty: "easy",
      question: "Python me variable name kis cheez se start nahi ho sakta?",
      options: ["Letter", "Underscore", "Digit", "Word"],
      correctIndex: 2,
      explanation: "Python me variable name digit se start nahi ho sakta. Letter ya underscore se start kiya ja sakta hai.",
    },
    {
      id: "py-extra-var-2",
      difficulty: "easy",
      question: "Konsa data type decimal value ko represent karta hai?",
      options: ["int", "float", "str", "bool"],
      correctIndex: 1,
      explanation: "Decimal ya fractional value ke liye float use hota hai.",
    },
  ],
  "input-output": [
    {
      id: "py-extra-io-1",
      difficulty: "easy",
      question: "input() function se li gai value default tor par kis type me hoti hai?",
      options: ["int", "float", "str", "bool"],
      correctIndex: 2,
      explanation: "input() default tor par string return karta hai. Number par kaam karne ke liye cast karna padta hai.",
    },
    {
      id: "py-extra-io-2",
      difficulty: "easy",
      question: "Aik line me text aur variable value dikhane ke liye kya use kiya ja sakta hai?",
      options: ["print()", "append()", "remove()", "sort()"],
      correctIndex: 0,
      explanation: "print() text aur variable dono ko output me show kar sakta hai.",
    },
  ],
  operators: [
    {
      id: "py-extra-op-1",
      difficulty: "medium",
      question: "Python me '/' operator ka result kis type ka hota hai?",
      options: ["Hamesha int", "Hamesha float", "Hamesha bool", "Hamesha string"],
      correctIndex: 1,
      explanation: "Normal division '/' ka result Python me float hota hai.",
    },
    {
      id: "py-extra-op-2",
      difficulty: "medium",
      question: "Floor division ke liye konsa operator use hota hai?",
      options: ["%", "//", "**", "=="],
      correctIndex: 1,
      explanation: "'//' floor division karta hai aur decimal part ko drop kar deta hai.",
    },
  ],
  "if-else": [
    {
      id: "py-extra-if-1",
      difficulty: "easy",
      question: "Multiple conditions check karne ke liye if aur else ke darmiyan kya use hota hai?",
      options: ["elif", "loop", "print", "def"],
      correctIndex: 0,
      explanation: "elif extra conditions check karne ke liye use hota hai.",
    },
    {
      id: "py-extra-if-2",
      difficulty: "easy",
      question: "Comparison operator '==' kis liye use hota hai?",
      options: ["Value assign karne ke liye", "Values compare karne ke liye", "Loop chalane ke liye", "Comment likhne ke liye"],
      correctIndex: 1,
      explanation: "'==' do values ko compare karta hai ke dono equal hain ya nahi.",
    },
  ],
  loops: [
    {
      id: "py-extra-loop-1",
      difficulty: "medium",
      question: "range(5) kitni values generate karta hai?",
      options: ["4", "5", "6", "0"],
      correctIndex: 1,
      explanation: "range(5) 0 se 4 tak total 5 values generate karta hai.",
    },
    {
      id: "py-extra-loop-2",
      difficulty: "medium",
      question: "Infinite loop kis surat me ban sakta hai?",
      options: ["Condition update na ho", "print() use ho", "Variable declare ho", "List create ho"],
      correctIndex: 0,
      explanation: "Agar loop condition ko false karne wali update miss ho jaye to infinite loop ban sakta hai.",
    },
  ],
  functions: [
    {
      id: "py-extra-fn-1",
      difficulty: "easy",
      question: "Python me function define karne ke liye konsa keyword use hota hai?",
      options: ["func", "define", "def", "return"],
      correctIndex: 2,
      explanation: "Python me function define karne ke liye def keyword use hota hai.",
    },
    {
      id: "py-extra-fn-2",
      difficulty: "medium",
      question: "return statement ka basic role kya hota hai?",
      options: ["Loop stop karna", "Function ka result wapas dena", "Comment likhna", "Input lena"],
      correctIndex: 1,
      explanation: "return function ke result ko caller ke paas wapas bhejta hai.",
    },
  ],
  lists: [
    {
      id: "py-extra-list-1",
      difficulty: "easy",
      question: "Python list ka first index kya hota hai?",
      options: ["1", "-1", "0", "Depends on size"],
      correctIndex: 2,
      explanation: "Python list zero-based indexing follow karti hai.",
    },
    {
      id: "py-extra-list-2",
      difficulty: "medium",
      question: "List se specific value remove karne ke liye kya use hota hai?",
      options: ["append()", "remove()", "len()", "input()"],
      correctIndex: 1,
      explanation: "remove() given value ko list se nikalta hai.",
    },
  ],
};

export const researchedMcqAdditionsByUnit: Partial<Record<ComputerMcqUnit, ComputerMcq[]>> = {
  sdlc: [
    {
      id: "sdlc-extra-1",
      difficulty: "easy",
      question: "Feasibility study ka basic purpose kya hota hai?",
      options: ["Project ko decorate karna", "Yeh check karna ke project practical hai ya nahi", "Sirf coding start karna", "Sirf testing karna"],
      correctIndex: 1,
      explanation: "Feasibility study dekhati hai ke project time, cost aur resources ke hisab se practical hai ya nahi.",
    },
    {
      id: "sdlc-extra-2",
      difficulty: "medium",
      question: "Prototyping model kab zyada useful hota hai?",
      options: ["Jab requirements bilkul clear hon", "Jab requirements unclear hon aur feedback chahiye ho", "Jab testing avoid karni ho", "Jab project already complete ho"],
      correctIndex: 1,
      explanation: "Prototyping unclear requirements ki surat me quick feedback lene ke liye useful hota hai.",
    },
    {
      id: "sdlc-extra-3",
      difficulty: "easy",
      question: "UML ka full form kya hai?",
      options: ["Unified Modeling Language", "Universal Machine Logic", "User Model Layout", "Unified Module Link"],
      correctIndex: 0,
      explanation: "UML ka full form Unified Modeling Language hai.",
    },
    {
      id: "sdlc-extra-4",
      difficulty: "medium",
      question: "Software maintenance phase me aam tor par kya hota hai?",
      options: ["Requirements collect hoti hain", "Release ke baad bugs fix aur improvements hoti hain", "Sirf logo choose hota hai", "Sirf budget estimate hota hai"],
      correctIndex: 1,
      explanation: "Maintenance phase release ke baad bug fixing aur improvement ke liye hoti hai.",
    },
  ],
  algorithm: [
    {
      id: "alg-extra-1",
      difficulty: "easy",
      question: "Heuristic approach ka simple matlab kya hota hai?",
      options: ["Exact guaranteed answer", "Rule of thumb use karke solution tak pohanchna", "Data ko delete karna", "Output ko ignore karna"],
      correctIndex: 1,
      explanation: "Heuristic approach me practical rule of thumb use hota hai jo fast solution tak pohanchne me help karta hai.",
    },
    {
      id: "alg-extra-2",
      difficulty: "easy",
      question: "Flowchart me decision symbol aam tor par kis shape ka hota hai?",
      options: ["Rectangle", "Circle", "Diamond", "Triangle"],
      correctIndex: 2,
      explanation: "Decision symbol flowchart me diamond shape ka hota hai.",
    },
    {
      id: "alg-extra-3",
      difficulty: "medium",
      question: "Pseudocode ka main faida kya hai?",
      options: ["Compiler ke baghair human-readable steps likhna", "Sirf memory bachana", "Internet speed barhana", "Code ko encrypt karna"],
      correctIndex: 0,
      explanation: "Pseudocode natural language style me logic samjhane ke liye useful hota hai.",
    },
    {
      id: "alg-extra-4",
      difficulty: "medium",
      question: "Decomposition problem solving me kya karti hai?",
      options: ["Problem ko chhote parts me tod deti hai", "Solution ko random bana deti hai", "Data ko hide karti hai", "Sirf output likhti hai"],
      correctIndex: 0,
      explanation: "Decomposition complex problem ko chhote manageable parts me divide karti hai.",
    },
  ],
  "data-structures": [
    {
      id: "ds-extra-1",
      difficulty: "easy",
      question: "Queue kis principle ko follow karti hai?",
      options: ["LIFO", "FIFO", "Random", "Recursive"],
      correctIndex: 1,
      explanation: "Queue First In First Out principle follow karti hai.",
    },
    {
      id: "ds-extra-2",
      difficulty: "medium",
      question: "Stack me top item ko bina remove kiye dekhne ka operation kya kehlata hai?",
      options: ["Push", "Peek", "Insert", "Traverse"],
      correctIndex: 1,
      explanation: "Peek operation top item ko sirf dekhta hai, remove nahi karta.",
    },
    {
      id: "ds-extra-3",
      difficulty: "easy",
      question: "Graph me vertices ko kis cheez ke zariye connect kiya jata hai?",
      options: ["Arrays", "Edges", "Indexes", "Loops"],
      correctIndex: 1,
      explanation: "Graph me vertices ko edges connect karti hain.",
    },
    {
      id: "ds-extra-4",
      difficulty: "medium",
      question: "Binary tree me aik node ke maximum kitne children ho sakte hain?",
      options: ["1", "2", "3", "Unlimited"],
      correctIndex: 1,
      explanation: "Binary tree me har node ke maximum 2 children ho sakte hain.",
    },
  ],
  "data-analytics": [
    {
      id: "da-extra-1",
      difficulty: "easy",
      question: "Time ke sath trend dikhane ke liye konsa chart zyada suitable hota hai?",
      options: ["Line chart", "Pie chart", "Table only", "Text file"],
      correctIndex: 0,
      explanation: "Time-based trend ko line chart se asani se dikhaya jata hai.",
    },
    {
      id: "da-extra-2",
      difficulty: "medium",
      question: "Clustering ka basic purpose kya hota hai?",
      options: ["Labeled prediction karna", "Milti julati items ko groups me rakhna", "Code compile karna", "Files encrypt karna"],
      correctIndex: 1,
      explanation: "Clustering similar data points ko aik group me collect karti hai.",
    },
    {
      id: "da-extra-3",
      difficulty: "medium",
      question: "Linear regression me dependent variable aam tor par kis cheez ko represent karta hai?",
      options: ["Jo value predict karni ho", "Sirf heading", "Graph ka color", "Input list ki length"],
      correctIndex: 0,
      explanation: "Dependent variable wo hoti hai jis ka andaza ya prediction lagaya jata hai.",
    },
    {
      id: "da-extra-4",
      difficulty: "easy",
      question: "Visualization ka aik basic faida kya hai?",
      options: ["Data ko mushkil banana", "Patterns ko jaldi samajhna", "Storage delete karna", "Server manage karna"],
      correctIndex: 1,
      explanation: "Visualization se patterns aur trends ko jaldi samajhna easy hota hai.",
    },
  ],
  "emerging-tech": [
    {
      id: "et-extra-1",
      difficulty: "easy",
      question: "IaaS ka full form kya hai?",
      options: ["Internet as a Service", "Infrastructure as a Service", "Interface as a Software", "Integrated as a Server"],
      correctIndex: 1,
      explanation: "IaaS ka full form Infrastructure as a Service hai.",
    },
    {
      id: "et-extra-2",
      difficulty: "easy",
      question: "Public cloud ki basic khasusiyat kya hai?",
      options: ["Sirf aik organization ke liye hota hai", "Internet par broad access ke sath available hota hai", "Offline only hota hai", "Sirf blockchain ke liye hota hai"],
      correctIndex: 1,
      explanation: "Public cloud broad internet access ke sath multiple users ke liye available hota hai.",
    },
    {
      id: "et-extra-3",
      difficulty: "medium",
      question: "Blockchain me har block kis cheez se linked hota hai?",
      options: ["Random website se", "Pichlay block se", "Keyboard se", "Monitor se"],
      correctIndex: 1,
      explanation: "Blockchain me naya block pichlay block se linked hota hai jis se chain banti hai.",
    },
    {
      id: "et-extra-4",
      difficulty: "medium",
      question: "Edge computing me processing source ke paas kyun ki jati hai?",
      options: ["Latency kam karne ke liye", "Data ko delete karne ke liye", "Cloud band karne ke liye", "Screen resolution barhane ke liye"],
      correctIndex: 0,
      explanation: "Source ke paas processing karne se delay ya latency kam hoti hai.",
    },
  ],
  "legal-ethics": [
    {
      id: "le-extra-1",
      difficulty: "easy",
      question: "Digital footprint se kya murad hai?",
      options: ["Computer ka hardware size", "Online activities ka trace", "Internet package", "Screen ki brightness"],
      correctIndex: 1,
      explanation: "Digital footprint user ki online activities ka trace hota hai jo internet par reh jata hai.",
    },
    {
      id: "le-extra-2",
      difficulty: "medium",
      question: "Personal data collect karne se pehle ethical tor par kya zaroori hai?",
      options: ["Secretly copy karna", "User ki permission ya consent lena", "Data sell kar dena", "Password mang lena"],
      correctIndex: 1,
      explanation: "Ethical data collection ke liye consent lena zaroori hota hai.",
    },
    {
      id: "le-extra-3",
      difficulty: "easy",
      question: "Cyberbullying ka simple matlab kya hai?",
      options: ["Online kisi ko tang ya harm karna", "System update karna", "Cloud use karna", "Coding seekhna"],
      correctIndex: 0,
      explanation: "Cyberbullying me digital platforms par kisi ko tang ya harm kiya jata hai.",
    },
    {
      id: "le-extra-4",
      difficulty: "medium",
      question: "Strong password ki aik khasusiyat kya hoti hai?",
      options: ["Sirf name use ho", "Letters, numbers aur symbols ka mix ho", "Bohat short ho", "Har website par same ho"],
      correctIndex: 1,
      explanation: "Strong password me mixed characters hote hain aur woh guess karna mushkil hota hai.",
    },
  ],
  "digital-literacy": [
    {
      id: "dl-extra-1",
      difficulty: "easy",
      question: "OR operator search results par aam tor par kya asar dalta hai?",
      options: ["Results ko narrow karta hai", "Results ko broaden karta hai", "Har result delete karta hai", "Date hide karta hai"],
      correctIndex: 1,
      explanation: "OR operator different alternatives ko include karke results broaden karta hai.",
    },
    {
      id: "dl-extra-2",
      difficulty: "medium",
      question: "Plagiarism se bachne ka sahi tareeqa kya hai?",
      options: ["Source chhupa dena", "Proper citation aur reference dena", "Poora text copy kar dena", "Date remove kar dena"],
      correctIndex: 1,
      explanation: "Plagiarism se bachne ke liye proper citation aur reference zaroori hota hai.",
    },
    {
      id: "dl-extra-3",
      difficulty: "medium",
      question: "Advanced search me site: operator kis liye useful hota hai?",
      options: ["Specific website ke andar search karne ke liye", "Computer shutdown karne ke liye", "Passwords save karne ke liye", "Offline files delete karne ke liye"],
      correctIndex: 0,
      explanation: "site: operator specific domain ya website ke andar focused search ke liye useful hota hai.",
    },
    {
      id: "dl-extra-4",
      difficulty: "easy",
      question: "Citation ka main purpose kya hota hai?",
      options: ["Apni originality chhupana", "Original source ko acknowledge karna", "Search stop karna", "Ads remove karna"],
      correctIndex: 1,
      explanation: "Citation original source ko acknowledge karti hai aur academic honesty show karti hai.",
    },
  ],
  entrepreneurship: [
    {
      id: "en-extra-1",
      difficulty: "easy",
      question: "Entrepreneur aam tor par kis cheez ke liye jana jata hai?",
      options: ["Calculated risk lene ke liye", "Sirf copying ke liye", "Har idea reject karne ke liye", "Sirf theory yaad karne ke liye"],
      correctIndex: 0,
      explanation: "Entrepreneur calculated risk lekar new value create karne ki koshish karta hai.",
    },
    {
      id: "en-extra-2",
      difficulty: "medium",
      question: "USP ka simple matlab kya hota hai?",
      options: ["Unique Selling Proposition", "Universal Sales Process", "Unit Start Plan", "User Security Policy"],
      correctIndex: 0,
      explanation: "USP wo khas point hota hai jo product ko doosron se alag dikhata hai.",
    },
    {
      id: "en-extra-3",
      difficulty: "easy",
      question: "Revenue ka basic matlab kya hota hai?",
      options: ["Total income from sales", "Sirf net profit", "Sirf tax amount", "Sirf marketing cost"],
      correctIndex: 0,
      explanation: "Revenue total income hoti hai jo sales se aati hai.",
    },
    {
      id: "en-extra-4",
      difficulty: "medium",
      question: "Prototype ka use startup idea me kyun kiya jata hai?",
      options: ["Idea ko test aur improve karne ke liye", "Business band karne ke liye", "Tax avoid karne ke liye", "Staff remove karne ke liye"],
      correctIndex: 0,
      explanation: "Prototype se idea ko early stage me test karke improve kiya ja sakta hai.",
    },
  ],
};
